var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"width":_vm.getWidth()}},[(_vm.title !== undefined)?_c('v-card-title',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-card-text',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }